<template>
	<div class="text-primary checkoutTotalComponent">
		<div
			v-if="shouldShowAmountDue"
			class="contents">
			<div class="flex justify-between">
				<p class="font-serif text-3xl">{{ $t("totalDue") }}</p>
				<p class="font-serif text-3xl">{{ currency.symbol }}{{ parseFloat(amountDueToday).toFixed(2) }}</p>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { useCurrencyStore } from "~/stores/CurrencyStore"
	import { storeToRefs } from "pinia"
	import { useCartStore } from "~/stores/CartStore"
	import { useAmountDueToday } from "~/composables/useAmountDueToday"

	const currencyStore = useCurrencyStore()
	const { currency } = storeToRefs(currencyStore)

	const cartStore = useCartStore()
	const { total, installments, creditAppliedTotal } = storeToRefs(cartStore)
	const { amountDueToday, shouldShowAmountDue } = useAmountDueToday(total, creditAppliedTotal, installments)
</script>

<style scoped></style>
